import { Injectable } from '@angular/core';
import { Observable, shareReplay, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiCacheService {
  private cache = new Map<string, Observable<any>>();

  get<T>(key: string, requestFn: () => Observable<T>, ttl = 300000): Observable<T> {
    const cached = this.cache.get(key);

    if (!cached) {
      const request$ = requestFn().pipe(
        shareReplay(1),
        tap(() => {
          setTimeout(() => this.cache.delete(key), ttl);
        })
      );

      this.cache.set(key, request$);
    }

    return this.cache.get(key)!;
  }

  // optional: clear specific cache
  invalidate(key: string) {
    this.cache.delete(key);
  }

  // clear everything
  clear() {
    this.cache.clear();
  }
}
